module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-900italic.11ca70b25fd28cf67f917ce017b03e5a.woff";